import { PermissionDtolist } from 'src/models/permission';

export const accessControl = (permissionCode) => {
  const permissions = JSON.parse(
    sessionStorage.getItem('permissions')
  ) as PermissionDtolist[];

  if (!permissions) {
    return null;
  }

  const permission = permissions.find((p) => p.code === permissionCode);

  return permission;
};
